angular.module('ikeweb.spike.capture')
    .factory('spikeCaptureService', ['SpikeUtil', 'captureFactory', 'spikeImageService', 'promiseFactory',

        function spikeCaptureService(SpikeUtil, captureFactory, spikeImageService, promiseFactory) {

            var GENERATE_THUMBNAIL_FUNCTION = 'generateThumbnail';
            var DESKEW_CAPTURE_FUNCTION = 'deskewCapture';
            var ALIGN_CAPTURE_FUNCTION = 'alignCapture';

            var Capture = captureFactory.Capture;

            function populateCapture(capture) {
                capture.captureDate = moment(capture.get('timestamp'));
                capture.populate();
                return capture;
            }

            function populateCaptures(captures) {
                return captures.map(populateCapture);
            }

            function query() {
                return new Parse.Query(Capture)
                    .include('folder')
                    .addDescending('createdAt')
                    .limit(1000); // set a large upper limit to results
            }

            function loadImage(url) {
                if (!url) {
                    return Parse.Promise.error('Image does not exist');
                }

                var image = new Image();
                return spikeImageService.setImageSrc(image, url);
            }

            function generateThumbnail(capture) {
                return Parse.Cloud.run(GENERATE_THUMBNAIL_FUNCTION, {
                    captureuuid: capture.getCaptureUuid()
                });
            }

            function generateDeskewedImage(capture) {
                return Parse.Cloud.run(DESKEW_CAPTURE_FUNCTION, {
                    captureuuid: capture.getCaptureUuid()
                });
            }

            function generateAlignmentPoints(capture) {
                return Parse.Cloud.run(ALIGN_CAPTURE_FUNCTION, {
                    captureuuid: capture.getCaptureUuid()
                });
            }

            return {
                listCaptures: function(folderId) {
                    var listQuery = query();
                    if (folderId) {
                        listQuery.equalTo('folder', new Parse.Object('Folder', {
                            id: folderId
                        }));
                    }

                    return listQuery
                        .find()
                        .then(populateCaptures);
                },

                getCapture: function(captureid) {
                    return query().get(captureid).then(populateCapture);
                },

                getCaptureImage: function(capture, scaled) {
                    if (scaled) {
                        return loadImage(capture.getScaledImage())
                            .catch(function() {
                                return generateThumbnail(capture)
                                    .then(function(capture) {
                                        return loadImage(capture.getScaledImage());
                                    });
                            });
                    }
                    return loadImage(capture.getAlignedImage());
                },

                getCaptureImageDeskewed: function(capture, scaled) {
                    return generateDeskewedImage(capture)
                        .then(function(urlMap) {
                            return scaled ? urlMap.thumbnail : urlMap.full;
                        });
                },
                getAutoAlignmentPolygon: function(capture) {
                    return generateAlignmentPoints(capture);
                },

                putCapturesInFolder: function(captures, folder) {
                    captures.map(function(capture) {
                        capture.set('folderName', folder.getName());
                    });
                    return Parse.Object.saveAll(captures);
                },

                saveMeasurementsForCapture: function(capture, measurements) {
                    capture.measurements = measurements;
                    capture.serialize();
                    return promiseFactory.resolvedPromise();
                },
                saveNoteForCapture: function(capture, note) {
                    if (capture.getNote() !== note) {
                        capture.setNote(note);
                    }
                    return promiseFactory.resolvedPromise();
                },
                renameCapture: function(capture, name) {
                    if (capture.getName() !== name) {
                        capture.setName(name);
                        return capture.save();
                    }
                    return Parse.Promise.as(capture);
                },

                deleteCaptures: function(captures) {
                    return captures.length > 0 ?
                        Parse.Object.destroyAll(captures, {
                            wait: true
                        }) :
                        Parse.Promise.as();
                }
            };
        }
    ])
    .config(['$provide',
        function($provide) {

            var functionsToCache = ['listCaptures', 'getCapture'];
            var functionsThatFlush = ['putCapturesInFolder', 'saveMeasurementsForCapture', 'deleteCaptures', 'renameCapture', 'saveNoteForCapture'];
            var functionsToDecorate = functionsToCache.concat(functionsThatFlush, 'getCaptureImage');

            $provide.decorator('spikeCaptureService', ['$delegate', 'qPromiseDecoratorService',
                function($delegate, qPromiseDecoratorService) {
                    return qPromiseDecoratorService.decorateDelegateWithPromise($delegate, functionsToDecorate);
                }
            ]);

            $provide.decorator('spikeCaptureService', ['$delegate', 'parseErrorDecoratorService',
                function($delegate, parseErrorDecoratorService) {
                    return parseErrorDecoratorService.decorateDelegatePromiseErrors($delegate, functionsToDecorate, {
                        101: 'CAPTURE_NOT_FOUND'
                    });
                }
            ]);

            $provide.decorator('spikeCaptureService', ['$delegate', 'cacheDecoratorBuilder', 'userHashService',
                function($delegate, cacheDecoratorBuilder, userHashService) {
                    return cacheDecoratorBuilder
                        .aCacheDecorator()
                        .withTTL(moment.duration(1, 'minutes').asMilliseconds())
                        .withHash(userHashService.hash)
                        .build()
                        .decorateDelegateWithCaching($delegate, functionsToCache, functionsThatFlush);
                }
            ]);

            $provide.decorator('spikeCaptureService', ['$delegate', 'promiseProgressDecoratorService',
                function($delegate, promiseProgressDecoratorService) {
                    return promiseProgressDecoratorService.decorateDelegateWithProgress($delegate, functionsToDecorate);
                }
            ]);

            $provide.decorator('spikeCaptureService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService',
                function($delegate, decoratedPromiseBuilder, notificationService) {

                    return decoratedPromiseBuilder
                        .forDelegate($delegate)
                        .decorate('renameCapture')
                        .onSuccess(notificationService.success('NOTIFICATION.CAPTURE.RENAME_CAPTURE', 'NOTIFICATION.CAPTURE.CAPTURE_RENAMED'))
                        .onError(notificationService.error('NOTIFICATION.CAPTURE.RENAME_CAPTURE', 'NOTIFICATION.CAPTURE.RENAME_PROBLEM'))
                        .decorate('getCapture')
                        .onError(notificationService.error('NOTIFICATION.CAPTURE.FETCH_CAPTURE', 'NOTIFICATION.CAPTURE.FETCH_PROBLEM'))
                        .fork();
                }
            ]);

            $provide.decorator('spikeCaptureService', ['$delegate', 'loggingDecorator',
                function($delegate, loggingDecorator) {
                    return loggingDecorator.decorateDelegateWithLogging($delegate, functionsToDecorate);
                }
            ]);
        }
    ]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/capture/capture.service.js
// module id = 511
// module chunks = 0